module.exports = __webpack_public_path__ + "img/barra-naranja-gris.3d34da75.svg";